<template>
    <div>
        <v-dialog v-model="progressDialogVisible" max-width="900px">
          <v-card>
            <v-card-title>
                {{ $t('performancemanagement.addkpiprogress') }}
            </v-card-title>
            <v-card-text class="pt-4">
              <v-container>

                    <div>
                        <v-row class="pb-n4 mt-2">
                            <v-col cols="3" class="ml-0 pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.reviewdate')"
                                    type="date"
                                    :rules="[rules.required]"
                                    v-model="formData.reviewdate"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="9">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.reviewedby')"
                                    type="text"
                                    ref="reviewerid"
                                    :rules="[rules.required]"
                                    v-model="formData.reviewerid"
                                    dense
                                    :items="staffList"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="pb-n4 mt-n8">
                            <v-col cols="3" class="ml-0 pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.achievement')"
                                    type="number"
                                    :rules="[rules.required]"
                                    v-model="formData.achievement"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="2">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.progressInPercentage')"
                                    type="number"
                                    v-model="formData.progress"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="pb-n4 mb-4 mt-n8">
                            <v-col cols="12" class="ml-0 pl-0">
                                <v-textarea
                                    outlined
                                    :label="$t('performancemanagement.comments')"
                                    type="text"
                                    v-model="formData.comment"
                                    dense
                                ></v-textarea>
                            </v-col>
                        </v-row>

                         <v-row>
                            <v-col cols="11" sm="11" class="pb-n5 mt-n8">
                                <v-file-input 
                                    ref="attach"
                                    :label="formData.attach ? 'Reference: ' + formData.attachname : 'No file selected'" 
                                    outlined 
                                    v-model="fileHolder"
                                    @change="fileToBase64('formData')"
                                    dense
                                ></v-file-input>
                            </v-col>
                            <v-col cols="1" sm="1" class="pb-n5 mt-n4">
                                <v-icon
                                    class="ml-2"
                                    @click="deleteItemHandler"
                                >
                                    mdi-delete
                                </v-icon>
                            </v-col>
                        </v-row>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="saveProgressReview">{{$t('button.save')}}</v-btn>
                <v-btn color="red darken-1" text @click="closeDialog">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object,
        progressDialogVisible: Boolean,

    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: this.parentObject.indkpiid,
                reviewerid: this.parentObject.reviewerid,
                target: this.parentObject.target,
                calcmethod: this.parentObject.calcmethod,
                reviewdate : null,
                achievement: null,
                progress: 0,
                comment: null,
                attach: null,
                attachname: null,
                userid: this.$store.getters.userId,
                stamp: 0,
            },

            staffList: [],
            staffid: this.parentObject.staffid,

            ratingdialog: false,
            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

    watch: {
        // Watch for changes in achievement and calculate progress
        'formData.achievement'(newValue) {
            if (newValue) {
                //If based on percentage, use normal way. Else, use achievement as progress
                if (this.formData.basedonpercentage) {
                    if (this.formData.calcmethod == 1){ //Achievement/Target
                        this.formData.progress = (newValue / this.formData.target) * 100; 
                    }else if(this.formData.calcmethod == 2){ //Target/Achievement
                        this.formData.progress = ( this.formData.target / newValue) * 100; 
                    }
                }else{
                    this.formData.progress = newValue; //Direct input
                }
            } else {
                this.formData.progress = 0;
            }
        }
    },

    methods: {
        fileToBase64() {
          if (this.fileHolder) {
            var file = this.$refs.attach.internalValue;
                this.formData.attachname = this.fileHolder.name
            
            var reader = new FileReader();

            reader.onloadend = () => {
                //var b64 = reader.result.replace(/^data:.+base64,/, '');
                var b64 = reader.result;
                  this.formData.attach = b64
            }

            reader.readAsDataURL(file);
          } else {
                this.formData.attach = null
          }
        },
        
        deleteItemHandler() {
          this.formData.attach = ''
          this.formData.attachname = ''
        },

        loadStaffList() {
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', { url: "/staff/all/" + this.$store.getters.userId })
                .then((res) => {

                    const staffRecords = res.data.rec;

                    // Filter staff records where cessadate > today's date
                    const filteredStaff = staffRecords.filter(staff => {
                        const cessadate = new Date(staff.cessadate);
                        return cessadate > today && staff.id !== this.staffid;
                    });

                    vm.staffFull = filteredStaff;

                    // Populate staffList with filtered data
                    vm.staffList = filteredStaff.map(staff => ({
                        text: staff.psndetails,
                        value: staff.id,
                    }));

                }).catch((err) => {
                    console.error(err);
                });

        },

      

        openProgressReview() {
            this.ratingdialog = true;
        },

        saveProgressReview() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                return false;
            }


            this.$store.dispatch('post', {url: "/kpiindividual/progressreview/create/", payload: vm.formData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    vm.$emit('add-progress-review', res.data.result); // Emit result data to KPICardIndividual
                    this.closeDialog();
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        closeDialog() {
            this.$emit('update:progressDialogVisible', false); // Update close to progressDialogVisible in KPICardIndividual
            this.isErr = false;
            this.isExisting = false;

            // // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                reviewerid: this.parentObject.reviewerid,
                reviewdate : null,
                achievement: null,
                progress: 0,
                comment: null,
            };
        },          
    },

    mounted() {
        this.loadStaffList();
        console.log(this.parentObject);
    }
}
</script>

<style scoped>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: -8px;
}

.mdi-pen::before {
  margin-top: -8px;
}

.radio-label {
    left: 5px;
    position: relative;
}
</style>